import Balance from '../Balance'
import { Card, Typography, Spin, Statistic } from 'antd'
import { option } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { memoed, loadable } from '@library/react-toolkit'
import AmountCard from './AmountCard'

const Statistics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 24px;
`

const DateStatistc = styled(Statistic)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 8px;
  max-width: 280px;
  & > *.ant-statistic-content {
    font-size: 16px;
    margin-bottom: 4px;
  }
  & > .ant-statistic-title {
    margin-right: 8px;
  }
`

const DashboardSummary = () => {
  const intl = useIntl()
  const { loading, lastTransferDate } = useSelector(s => ({
    loading: loadable.isLoading(s.home.lastTransferDate.v),
    lastTransferDate: memoed.extract(s.home.lastTransferDate),
  }))

  return (
    <Card style={{ marginBottom: 16 }}>
      <Typography.Title level={3}>
        <FormattedMessage id="dashboard" />
      </Typography.Title>
      <Statistics>
        <Card>
          <Balance>
            <Spin spinning={loading}>
              <DateStatistc
                title={<FormattedMessage id="lastTransfer" />}
                value={pipe(
                  lastTransferDate,
                  option.fold(
                    () => intl.formatMessage({ id: 'noTransfers' }),
                    d =>
                      intl.formatDate(d, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })
                  )
                )}
              />
            </Spin>
          </Balance>
        </Card>
        <AmountCard type="due" />
        <AmountCard type="paid" />
      </Statistics>
    </Card>
  )
}

export default DashboardSummary
